module.exports = __webpack_public_path__ + "static/media/img-pop-up-my-montepio-zippy-worten2.6c074c49.png";